import React from "react"
import { Box, Heading, Text, Image } from "theme-ui"
import { Link } from "gatsby"
import slugify from "slugify"
import FadeIn from "react-lazyload-fadein"

export const Banner = (props) => (
  <Box
    {...props}
    sx={{
      color: "background",
      bg: "text",
    }}
  >
    <Box
      sx={{
        // '*': { outline: '1px solid rgba(0, 255, 255, 0.5)', },
        display: "flex",
        flexDirection: "column",
        minHeight: "calc(100vh - 64px)",
        mx: "auto",
        px: [2, 4],
        py: [4, 5],
        h1: {
          variant: "text.caps",
          fontSize: 3,
        },
        pre: {
          p: 0,
          mb: 0,
          bg: "transparent",
        },
      }}
    >
      {props.children}
    </Box>
  </Box>
)

export const LogoGrid = (props) => (
  <Box
    {...props}
    sx={{
      display: "grid",
      gridGap: 3,
      gridTemplateColumns: ["auto", "auto", "1fr 2fr 1fr"],
      alignItems: "center",
    }}
  />
)

export const Grid = ({ width = 256, gap = 4, ...props }) => (
  <Box
    {...props}
    sx={{
      ul: {
        listStyle: "none",
        p: 0,
        display: "grid",
        gridGap: gap,
        gridTemplateColumns: [
          "auto",
          `repeat(auto-fit, minmax(${width}px, 1fr))`,
        ],
      },
      ...props.sx,
    }}
  />
)

export const NavGrid = (props) => (
  <Box
    {...props}
    sx={{
      ul: {
        listStyle: "none",
        p: 0,
        display: "grid",
        gridGap: 3,
        gridTemplateRows: [`repeat(9, 1fr)`, `repeat(5, 1fr)`],
        gridTemplateColumns: ["repeat(2, 1fr)", "repeat(4, 1fr)"],
        gridAutoFlow: ["dense", "column"],
        counterReset: "nav-grid",
      },
      li: {
        fontWeight: "bold",
        fontSize: 0,
        variant: "text.caps",
        counterIncrement: "nav-grid",
        mb: 0,
        "::before": {
          content: "counter(nav-grid)",
          display: "inline-block",
          width: 16,
          pr: [1, 2, 3],
        },
      },
      a: {
        color: "inherit",
        textDecoration: "none",
        transition: "color .2s ease-out",
        ":hover,:focus": {
          color: "primary",
        },
      },
    }}
  />
)

export const Title = (props) => {
  let fontSize = [4, 5, 6]

  if (props.h2) {
    fontSize = [3, 4, 5]
  } else if (props.h3) {
    fontSize = [3, 4, 4]
  }

  const title = props.children.replace(/^[#]+/, ""),
    slug = slugify(title.toLowerCase())

  return (
    <Heading
      {...props}
      sx={{
        fontSize,
        mx: "auto",
        mt: [4, 4, 5],
        mb: [1, 2, 3],
        textAlign: "center",
        width: "100%",
        maxWidth: "wide",
        ...props.sx,
      }}
      id={slug}
    >
      <Link
        to={`#${slug}`}
        style={{
          color: "inherit",
          textDecoration: "none",
          ":hover": {
            textDecoration: "underline",
          },
        }}
      >
        {title}
      </Link>
    </Heading>
  )
}

export const Testimonial = ({ name, company, quote, image }) => (
  <Box
    sx={{
      margin: "2rem auto",
      maxWidth: "600px",
      textAlign: "center",
      mt: 2,
    }}
  >
    <FadeIn height={340} sx={{ width: "100%" }}>
      {(onload) => (
        <>
          <Box
            sx={{
              margin: "1rem auto",
              width: "80%",
              padding: "20px",
              textAlign: "center",
              boxShadow: "0 5px 25px 0 rgba(0, 0, 0, 0.25)",
              borderRadius: "20px",
              fontFamily: 'Georgia, "Times New Roman", Times, serif',
              fontStyle: "italic",
              lineHeight: "28px",
              fontSize: "16px",
              transition: "all 0.15s ease",
              verticalAlign: "top",
            }}
          >
            {quote}
          </Box>
          <Image
            src={image}
            onLoad={onload}
            alt={`${name} testimonial`}
            sx={{
              borderRadius: "50%",
              display: "inline-block",
              height: "110px",
              margin: "1rem auto",
              verticalAlign: "middle",
            }}
          />

          <Box
            sx={{
              fontSize: 1,
              fontWeight: "bold",
            }}
          >
            {name}
          </Box>

          <Box
            sx={{
              fontSize: 0,
              fontWeight: "200",
            }}
          >
            {company}
          </Box>
        </>
      )}
    </FadeIn>
  </Box>
)
